module.exports = __webpack_public_path__ + "static/media/fill_58@3x.8f837974.png";